import { Outlet } from "react-router-dom";

import { VmgLogo } from "@/components";

export const AuthLayout = () => {
  return (
    <div className="flex min-h-screen flex-col items-center gap-y-10 pt-5">
      <VmgLogo className="size-24 text-primary-500" />
      <div className="flex w-1/3 flex-col gap-y-12">
        <Outlet />
      </div>
    </div>
  );
};
